import React, { FC } from 'react';

import { getExtension } from '@sv-support-sdk/utils/src/helpers/fileSizeFormat';
import useDownloadFile from '@sv-support-sdk/utils/src/hooks/useDownloadFile';

import Avatar from '@sv-support-sdk/ui-components/src/components/Media/Avatar';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import { useAppDispatch } from '../../../store/hooks';
import { showSomethingWentWrongError } from '../../../store/actions/notifications';
import { FILE_ICON_TYPES } from '../../../constants/messages';

import css from './style.module.scss';

interface IProps {
  name: string;
  extraIcon?: string;
  subtitle?: string;
  size: string;
  link: string;
  extension: string;
}

const MessageFile: FC<IProps> = ({ name, extraIcon, subtitle, size, link, extension }) => {
  const dispatch = useAppDispatch();

  const onErrorCallback = () => {
    dispatch(showSomethingWentWrongError());
  };

  const { uploadFile, progress, isLoading } = useDownloadFile(link, name, onErrorCallback);

  const extensionName = getExtension({ extension, name });
  const icon = FILE_ICON_TYPES[extensionName];

  return (
    <div onClick={uploadFile} className={css.message__file}>
      <div className={css.message__fileIcon}>
        <Avatar icon={icon} size="32" letters={extensionName} />
        {extraIcon && (
          <div className={css.message__fileIconOverlay}>
            <Icon id={extraIcon} />
          </div>
        )}
      </div>
      <div className={css.message__fileInfo}>
        <div className={css.message__fileName}>{name}</div>
        <div className={css.message__fileSubtitle}>
          {subtitle && <div className={css.message__fileSubtitleItem}>{subtitle}</div>}
          <div className={css.message__fileSubtitleItem}>{size}</div>
        </div>
      </div>
      {isLoading && progress ? (
        <div className={css.message__fileLoading} style={{ width: `${progress}%` }}></div>
      ) : null}
    </div>
  );
};

export default MessageFile;
